import { render, staticRenderFns } from "./GeneralRequests.vue?vue&type=template&id=4dc646b6&"
import script from "./GeneralRequests.vue?vue&type=script&lang=js&"
export * from "./GeneralRequests.vue?vue&type=script&lang=js&"
import style0 from "./GeneralRequests.vue?vue&type=style&index=0&id=4dc646b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports